import { useSelector } from 'react-redux';
import { ScanCode } from '../scan-code';
import { StyledMobileQRCodeButton, StyledQRCodeContainer, StyledQRCodeIcon } from './styles';
import { Modal } from '@/components/uielements/modal';
import { meSliceSelector } from '@/redux/me/reducer';

export const MobileQRCode = () => {
  const { data: me } = useSelector(meSliceSelector);

  if (!me?.qrcode) {
    return null;
  }

  return (
    <>
      <StyledQRCodeContainer>
        <Modal.Container
          trigger={(open) => (
            <StyledMobileQRCodeButton
              aria-label="Click to view your membership ID"
              onClick={() => open()}
            >
              <StyledQRCodeIcon>
                <img src="/static/img/icons/qr.svg" alt="" role="presentation" />
              </StyledQRCodeIcon>
              <p>Scan</p>
            </StyledMobileQRCodeButton>
          )}
        >
          {() => <ScanCode memberCode={me.qrcode} memberId={me?.external_user_fk} />}
        </Modal.Container>
      </StyledQRCodeContainer>
    </>
  );
};
